module.exports = require("remote");


//////////////////
// WEBPACK FOOTER
// external "remote"
// module id = 417
// module chunks = 0